import {createContext, useContext, useState, FC, useCallback, useEffect} from "react";
import {SelectedAssets} from "domains/drag-and-drop";

const AssetSelectionContext = createContext(null);

export const AssetSelectionProvider: FC = ({ children }) => {
  const [ selectedAssets, setSelectedAssets ] = useState<SelectedAssets>([]);

  const resetSelectedItems = (): void => setSelectedAssets([]);

  const handleClick = useCallback((e): void => {
    if (e.target.id !== 'dnd-asset') {
      resetSelectedItems();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ handleClick ]);

  return (
    <AssetSelectionContext.Provider value={{ selectedAssets, setSelectedAssets, resetSelectedItems }}>
      {children}
    </AssetSelectionContext.Provider>
  )
};

export const useAssetSelectionContext = () => useContext(AssetSelectionContext);
